import { match } from 'ts-pattern';
export const migrateToV2 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'SwimShorts'
        }, ({ inseam, ...entity })=>({
                ...entity,
                // Convert -0.5 to 0 and 0.5 to 0 as they want to support only -1, 0, 1
                inseam: inseam === -0.5 ? 0 : inseam === 0.5 ? 0 : inseam
            })).with({
            type: 'BoardShorts'
        }, ({ inseam, ...entity })=>({
                ...entity,
                // Convert -0.5 to 0 and 0.5 to 0 as they want to support only -1, 0, 1
                inseam: inseam === -0.5 ? 0 : inseam === 0.5 ? 0 : inseam
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v02.js.map